module.exports = __webpack_public_path__ + "img/rj.862b8b61.png";